<script lang="ts">
	import { onMount, createEventDispatcher } from "svelte";
	import { slide } from "svelte/transition";
	import { serpPageConfigStores } from "../../../stores/stores.serpPage";
	import { FilterStores, ParametersFilterResponse } from "../../../../types/types.serpPage";
	import { msg } from "../../../modules/utils.serpPage";
	import { Icon } from "../../../../generic/components";

	export let filter: FilterStores;

	let show: boolean = false;
	let isClosed: boolean = false;
	let isEmpty: boolean = false;
	let showMoreBtnVisible: boolean = false;
	let limit: number = $serpPageConfigStores.limitFilter ?? 0;
	let showMore: boolean = false;
	const dispatch = createEventDispatcher();

	onMount(() => {
		isClosed = $serpPageConfigStores.isFilterCloseOnStart ?? false;
		isEmpty = filter.currentValueSelected?.length == 0;
		show = !isClosed && !isEmpty;
		limit = $serpPageConfigStores.limitFilter ?? 0;
		showMoreBtnVisible = filter.currentValues.length > limit;
	});

	function toogleCollapse() {
		show = !show;
	}

	function handleClickMore() {
		showMore = !showMore;
		limit = showMore ? filter.currentValues.length : $serpPageConfigStores.limitFilter ?? 0;
	}

	function checkIsChecked(currentValue: ParametersFilterResponse): boolean {
		return filter.currentValueSelected?.length > 0 && filter.currentValueSelected.includes(currentValue.name);
	}

	function valueChanged(e: any) {
		dispatch("valueChanged", {
			value: e.target.value,
			filter: filter,
		});
	}
</script>

<button class="sidebarCollapseButton bsCollapse" class:collapsed={!show} on:click={toogleCollapse} type="button" title="" aria-expanded={show}>
	{filter.name}
	<Icon template="ic-arrow-down" styleClass="bsCollapseIcon" />
</button>
{#if show}
	<div class="px-3 py-2 border-top" in:slide={{ duration: 300 }}>
		{#each filter.currentValues.slice(0, limit) as currentValue}
			<div class="custom-control custom-checkbox" transition:slide={{ duration: 200 }}>
				<input type="checkbox" value={currentValue?.name} on:change={valueChanged} name={filter.name} checked={checkIsChecked(currentValue)} class="form-check-input" id="filter_{filter.name}_{currentValue.name}" />
				<label class="custom-control-label" for="filter_{filter.name}_{currentValue.name}">
					<span>{filter.getNameOfValue(currentValue.name)} <i>({currentValue.length})</i></span>
				</label>
			</div>
		{/each}
		{#if showMoreBtnVisible}
			<button type="button" on:click={handleClickMore} class="btnIcon text-decoration-underline px-3 py-2" title="">
				{showMore ? msg("less") : msg("more")}
			</button>
		{/if}
	</div>
{/if}
